import React, { useState } from 'react';

import SearchIcon from '@mui/icons-material/SearchOutlined';
import { Box, Button, IconButton, Menu } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TranslateFunction } from 'react-localize-redux';

import SettingsSearchBar from './SettingsSearchBar';

interface MobileSearchMenuProps {
  menuItems: any[];
  placeholder?: string;
  translate: TranslateFunction;
}

const RootContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

const StyledIconButton = styled(IconButton)({
  width: 40,
  height: 40,
});

const StyledMenu = styled(Menu)({
  width: '100vw',
  maxWidth: '100vw',
  padding: 2,
});

const MenuContentRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
});

const MobileSearchMenu: React.FC<MobileSearchMenuProps> = ({
  menuItems,
  placeholder,
  translate,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <RootContainer>
      <StyledIconButton
        data-fd="Open_search"
        aria-label={translate('Open_search') as string}
        onClick={handleOpen}
      >
        <SearchIcon />
      </StyledIconButton>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              width: '100vw',
              maxWidth: '100vw',
              p: 2,
              left: '0!important',
            },
          },
        }}
      >
        <MenuContentRow>
          <SettingsSearchBar
            menuItems={menuItems}
            placeholder={placeholder}
            onClickMenuItem={handleClose}
          />
          <Button onClick={handleClose} variant="text">
            {translate('Cancel')}
          </Button>
        </MenuContentRow>
      </StyledMenu>
    </RootContainer>
  );
};

export default MobileSearchMenu;
